const AuthUrlMap = {
    LOGIN_URL: '/auth/login',
    LOGIN_RETURN_URL: '/auth/login/return',
    LOGIN_XHR_URL: '/auth/login/xhr',
    ME_URL: '/auth/me',
    OAUTH_ME_URL: '/oauth/me',
    OAUTH_ME_XHR_URL: window.env.MILESTONES_AUTH_HOST + '/oauth/me/xhr',
    LOGOUT_URL: '/auth/logout',
    AUTH_LOGOUT_URL: window.env.MILESTONES_AUTH_HOST + '/logout',
    ONBOARDING_URL: window.env.MILESTONES_RE_HOST + '/onboarding',
    REFRESH_TOKEN_URL: '/auth/refresh-token',
};
export default AuthUrlMap;
